<template>
  <div class="panel panel-default version-card">
    <div class="panel-heading clearfix">
      <div class="pull-left ml-10 mt-10 header-title">
        <span class="h3-style"><b>Authoring Milestones </b></span>
      </div>
      <div class="pull-right mt-5 mr-10">
        <template v-if="isLoading === false">
          <template v-if="remainingMilestones.length === 0">
            <img
              class="trophy-icon"
              data-testid="success-trophy-cy"
              src="/capsiminbox/images/IAP-Dashboard_Icon_trophy_success.svg"
              alt="trophy icon"
            />
          </template>
          <template v-else>
            <img
              data-testid="trophy-cy"
              class="trophy-icon"
              src="/capsiminbox/images/IAP-Dashboard_Icon_trophy.svg"
              alt="trophy icon"
            />
          </template>
        </template>
      </div>
    </div>
    <div class="panel-body ml-10 mr-10 pb-10">
      <div class="row">
        <div class="col-md-12">
          <div class="progress">
            <div
              class="progress-bar"
              role="progressbar"
              data-testid="progress-bar-cy"
              :style="{ width: milestoneProgress }"
              :aria-valuenow="milestoneProgress"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              {{ milestoneProgress }}
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <table class="table">
            <thead>
              <tr>
                <th tabindex="0" scope="col">Achievements</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <div
                  class="table-body-style"
                  :style="
                    remainingMilestones.length === 0 ? 'max-height: 285px;' : 'height: 110px;'
                  "
                >
                  <div
                    class="col-md-12 pl-5 pt-5 pb-5 text-styling"
                    v-for="item in milestones"
                    :key="item.FK_milestoneKey"
                  >
                    <span class="text-desc-styling">
                      <img
                        width="25"
                        height="25"
                        src="/capsiminbox/images/IAP-Dashboard_Icon_check_small2.svg"
                        alt="check mark success icon"
                      />
                      <div class="row ml-20 pl-5" style="margin-top: -23px">
                        {{ item.description }}

                        <popover :content="tooltips.milestones[item.milestoneKey]"></popover>
                      </div>
                    </span>
                  </div>
                </div>
              </tr>
            </tbody>
          </table>
        </div>
        <template v-if="remainingMilestones.length > 0">
          <div class="col-md-12">
            <table class="table">
              <thead>
                <tr>
                  <th tabindex="0" scope="col">Remaining</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <div class="table-body-style-remaining">
                    <div
                      class="col-md-12 pl-10 pt-5 pb-5 pr-0 text-styling"
                      v-for="item in remainingMilestones"
                      :key="item.milestoneKey"
                    >
                      {{ item.description }}
                      <popover :content="tooltips.milestones[item.milestoneKey]"></popover>
                    </div>
                  </div>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState, mapActions, mapGetters } from 'vuex';
  import * as authorApi from '@authoringPlatform/../api/authors';
  import * as versionApi from '@authoringPlatform/../api/versions';
  import { isMilestoneAchieved } from '@authoringPlatform/../utils/iapValidation';
  export default {
    name: 'Milestones',

    async mounted() {
      // Doing a force check since api apparently isn't loading the data prior
      const milestonesResult = await authorApi.getMilestonesForAuthor(this.actorKey);
      this.manageInitialMilestone(milestonesResult);

      await this.setTenParticipantsNotif(milestonesResult);
    },

    methods: {
      ...mapActions(['SET_MILESTONE']),
      ...mapActions('versions', ['getAllVersions']),
      ...mapActions('user', ['disableOnboardVid', 'enableOnboardVid']),
      async setTenParticipantsNotif(milestones) {
        const allVersions = await versionApi.getList();

        if (allVersions.length > 0 && !isMilestoneAchieved(milestones, 12)) {
          const hasTenParticipants = await this.tenParticipantsCheck(allVersions);

          if (hasTenParticipants) {
            this.SET_MILESTONE({
              message: 'Ten Participants',
              tooltipDesc: this.tooltips.milestones['12'],
              timeout: 8000,
              milestoneKey: 12,
            });
          }
        }
      },

      async tenParticipantsCheck(versions) {
        const versionsForAuthor = versions.filter((version) => version.actorKey == this.actorKey);

        for (let version of versionsForAuthor) {
          const res = await versionApi.getParticipantCounts({ versionKey: version.versionKey });

          // check for 10 participants in a version
          if (res > 9) {
            return true;
          }
        }
        return false;
      },
      manageInitialMilestone(milestones) {
        if (!isMilestoneAchieved(milestones, 1)) {
          this.SET_MILESTONE({
            message: 'First Log-In',
            tooltipDesc: this.tooltips.milestones['1'],
            timeout: 8000,
            milestoneKey: 1,
            bypass: true,
          });
          this.enableOnboardVid();
        } else {
          this.disableOnboardVid();
        }
      },
    },

    computed: {
      ...mapGetters('versions', ['versionList']),
      ...mapState('user', ['actorKey', 'isAdmin']),
      ...mapState(['milestones', 'remainingMilestones', 'isLoading']),

      milestoneProgress() {
        let progressValue = (
          (this.milestones.length / (this.milestones.length + this.remainingMilestones.length)) *
          100
        ).toFixed(0);

        return progressValue + '%';
      },
    },
  };
</script>
<style lang="scss" scoped>
  @media (max-width: 1300px) {
    .trophy-icon {
      width: 32px;
      height: 32px;
      margin-top: 4px;
      margin-left: 2px;
    }
  }
  @media (min-width: 1301px) {
    .trophy-icon {
      width: 40px;
      height: 40px;
    }
  }

  .progress {
    height: 26px;
  }
  .progress-bar {
    font-size: 16px;
    padding-top: 3px;
  }
  .table {
    border: 1px solid lightgray;
  }
  .panel-body {
    min-height: 420px;
  }
  .text-desc-styling {
  }

  .text-styling {
    font-size: 16px;
  }

  .table-body-style-remaining {
    height: 110px;
  }

  .table-body-style,
  .table-body-style-remaining {
    overflow-y: auto;
  }
  .h3-style {
    font-size: 22px;
  }
  .fa-trophy {
    font-size: 26px;
  }
  .version-card {
    .panel-heading,
    .panel-footer {
      background: white;
    }
  }

  .panel-heading {
    border: 0px solid transparent;
  }
</style>
